import { render, staticRenderFns } from "./positions.vue?vue&type=template&id=87f6c0fe"
import script from "./positions.vue?vue&type=script&lang=js"
export * from "./positions.vue?vue&type=script&lang=js"
import style0 from "./positions.vue?vue&type=style&index=0&id=87f6c0fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports